<div class="box">

  <div class="pet">
    <div
      [class.cat]="simulation.pet.type === 'cat'"
      [class.dog]="simulation.pet.type === 'dog'"
    >
    </div>
  </div>

  <div class="bathtub"></div>
  <div class="bubble-row"></div>

  <div class="bubbles">
    <div class="bubble one"></div>
    <div class="bubble two"></div>
    <div class="bubble three"></div>
    <div class="bubble four"></div>
    <div class="bubble five"></div>
    <div class="bubble six"></div>
    <div class="bubble seven"></div>
  </div>

</div>
